import { FormPanelQueryState, FormPanelStatus } from "./types";

export const formPanelStatusOf = ({
  isLoading,
  isError,
}: FormPanelQueryState): FormPanelStatus => {
  if (isLoading) {
    return "loading";
  }
  if (isError) {
    return "error";
  }
  return "ready";
};
